
// import commonApi from '@/api/common';
import { defineComponent } from 'vue';
import { message as $message } from 'ant-design-vue';
import PayModal from '@/components/modal/payModal.vue';
import List from './components/list.vue';
import Detail from './components/modal/detail.vue';

export default defineComponent({
  name: 'PaymentRecord',
  components: {
    List,
    Detail,
    PayModal,
  },
  data() {
    return {
      payInfo: {},
    };
  },
  setup() {
    const error = (str: string) => {
      $message.error(str);
    };
    const success = (str: string) => {
      $message.success(str);
    };
    return {
      error,
      success,
    };
  },
  // mounted() {
  // },
  methods: {
    openDetailModal(item: TObject) {
      const child = this.$refs.detail as unknown as {[x: string]: Function};
      child.showVisible(item);
    },
    handleToPay(item: TObject) {
      const payfo = item;
      payfo.value = item.amount;
      this.payInfo = payfo;
      const refs = this.$refs as unknown as {payModal: {showModal: Function}};
      refs.payModal.showModal();
    },
  },
});
